export function convertArray(arr = [], number = 1) {
    const newArray = [];
    if(!arr?.length){
        return newArray
    }
    for (let i = 0; i < arr.length; i += number) {
        newArray.push(arr.slice(i, i + number));
    }
    return newArray;
}
